(function () {
    'use strict';

    /**
     *
     * @ngdoc service
     * @name adminCrewBatchers.service:CrewBatchService
     *
     * @description
     *
     */
    angular
        .module('bidding')
        .service('BiddingService', BiddingService);

    function BiddingService(BiddingFactory,ManageCrewFactory,RenewalsFactory, RemoteService,applicationConstants) {
        var self = this;

        self.searchCycleMasterData = function( successFn, errorFn){
        	RemoteService.getRosterCycles(true).then(
                  function (response) {
                  	  var formatedList = BiddingFactory.formateCycleMasterData(response.cycleList);
                      successFn(formatedList);
                  },
                  function (error) {
                      errorFn(error.msg[0]);
                  }
              );
        }



        self.searchFleetTypes = function(successFn, errorFn){
     	   RemoteService.getAircraftTypeList().then(
                    function (response) {
                 	   var formatedList = RenewalsFactory.formatFleetTypeResponse(response.aircraftTypeDTOs);
                        successFn(formatedList);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
             );
        }

        self.searchCrewBases = function(successFn, errorFn){
     	   RemoteService.getBaseList().then(
                    function (response) {
                 	   var formatedList = RenewalsFactory.formatCrewBaseResponse(response.baseListDTOs);
                        successFn(formatedList);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
             );
        }

        self.searchCrewGroups = function(successFn, errorFn){
        	RemoteService.getCrewGroups().then(
                    function (response) {
                        successFn(response.crewGroups);
                    },
                    function (error) {
                        errorFn(error.msg);
                    }
            );
        }

        self.searchCrewBiddingDetails = function(postData,successFn, errorFn){
        	if(postData.startPosition == 1){
        		self.biddingDataList = [];
        	}
        	var searchRequest = BiddingFactory.populateBiddingDetailsSearchRequest(postData);
        	RemoteService.searchBiddingDetails(searchRequest).then(
                    function (response) {
                    	var biddingList = BiddingFactory.formatCrewBiddingSearchData(response.biddingDetailsList);
                		self.biddingDataList = self.biddingDataList.concat(biddingList);
                        successFn(biddingList,response.startPosition);
                    },
                    function (error) {
                        errorFn(error.msg);
                    }
            );
        }

        self.directApproveBidding = function(postData,successFn, errorFn){
        	var request = BiddingFactory.populateDirrectApproveRequest(postData);
        	RemoteService.assignBiddingRequest(request).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error);
                    }
            );
        }

        self.approveBidCollection = function(postData, approvalType, successFn, errorFn) {
        	var request = BiddingFactory.populateApprveBidCollectionRequest(postData, approvalType);
        	RemoteService.assignBiddingRequest(request).then(
                    function (response) {
                        successFn(response);
                    },
                    function (errors) {
                        errorFn(error.msg);
                    }
            );

        }

        self.deleteBidCollection = function(postData, successFn, errorFn) {
        	var request = BiddingFactory.populateDeleteBidCollectionRequest(postData);
			RemoteService.deleteCrewBiddings(request).then(function(response) {
				successFn(response);
			}, function(errors) {
				errorFn(error.msg);
			});

        }

        self.resetDataCollection = function(dataCollection){
        	return BiddingFactory.resetDataCollection(dataCollection);
        }

        self.resetSelectedBid = function(dataCollection,selectedBid){
        	return BiddingFactory.resetSelectedBid(dataCollection,selectedBid);
        }

        self.searchCrewTypes = function(successFn, errorFn){
        	 RemoteService.getCrewTypeList().then(
                     function (response) {
                  	   var formatedList = ManageCrewFactory.formatCrewTypeResponse(response.crewTypeListDTOs);
                         successFn(formatedList);
                     },
                     function (error) {
                         errorFn(error.msg[0]);
                     }
               );
        }

        self.getNewBidRequest = function(){
        	return BiddingFactory.getNewBidRequest();
        }

        self.searchPatternDurationTypes = function(successFn, errorFn){
        	 RemoteService.loadPatternDurationTypes().then(
                     function (response) {
                    	 var durations = BiddingFactory.formatDurationTypeResponse(response.durationList);
                         successFn(durations);
                     },
                     function (error) {
                         errorFn(error.msg[0]);
                     }
               );
        }

        self.searchPatternDepartureTypes = function(successFn, errorFn){
	       	 RemoteService.loadPatternDepartureTypes().then(
	                    function (response) {
	                    	var departureTypes = BiddingFactory.formatDepatureTypeResponse(response.departureTypeList);
	                        successFn(departureTypes);
	                    },
	                    function (error) {
	                        errorFn(error.msg[0]);
	                    }
	              );
        }

        self.searchPatternNamesByCrewTypeAndReqDate = function(params,successFn, errorFn){
        	var requestParams = BiddingFactory.getPatternNamesSearchRequest(params);
        	RemoteService.loadPatternNamesByCrewTypeAndReqDate(
        			requestParams.crewTypeCode,
        			requestParams.requestDate).then(
                    function (response) {
                        successFn(response.patternNames);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
              );
        }


        self.createNewRequest = function(params,successFn, errorFn){
        	var requestParams = BiddingFactory.createNewBidRequest(params);
        	RemoteService.saveNewBidRequest(requestParams).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
            );
        }


        self.searchRequestPriorities = function(successFn, errorFn){
        	RemoteService.searchRequestPriorities().then(
                    function (response) {
                    	var requestPriorityList = BiddingFactory.formatRequestPrioritySearchResponse(response.requestPriorityList);
                        successFn(requestPriorityList);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
            );
        }

        self.getMaxCrewBidding = function(successFn, errorFn){
        	RemoteService.getMaxCrewBidding().then(
                    function (response) {
                    	var details = BiddingFactory.formatMaxCrewBiddingResponse(response.maxCrewBiddingsDTOs);
                    	successFn(details);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
            );
        }

        /**
         * Get All blocks for a Given Crew for a period
         * @param crewId
         * @param fromDate
         * @param toDate
         * @returns {Array}
         */
        self.getBlocksForCrew = function (crewId, fromDate, toDate) {
            var blocks,
                tMo,
                tMoFromDate = moment(fromDate, applicationConstants.SETTINGS.DATE_FORMAT),
                tMoToDate = moment(toDate, applicationConstants.SETTINGS.DATE_FORMAT),
                tmp = _.find(self.biddingDataList, {crewProfId: crewId});
            if (!!tmp) {
                blocks = tmp.biddingData.filter(
                        function (block) {
                            tMo = moment(block.biddingDate, applicationConstants.SETTINGS.DATE_FORMAT);
                            return tMo.isBetween(tMoFromDate, tMoToDate, null, '[]');
                        }
                    ) || [];
            }

            return blocks;
        };

        /**
         * Get set of crews between given from and to Crews
         * as appear in UI
         * @param selectedCrewCol  - []
         * @returns {Array}
         */
        self.getCrews = function (selectedCrewCol) {
            var returnCrews = [];
            var fromIndex = selectedCrewCol.reduce(function (previous, current) {
                if (previous == -1) {
                    return _.findIndex(self.biddingDataList, {crewProfId: current.crewProfId});
                } else {
                    var index = _.findIndex(self.biddingDataList, {crewProfId: current.crewProfId});
                    if (index < previous) {
                        return index;
                    } else {
                        return previous;
                    }
                }
            }, -1);


            var toIndex = selectedCrewCol.reduce(function (previous, current) {
                if (previous == -1) {
                    return _.findIndex(self.biddingDataList, {crewProfId: current.crewProfId});
                } else {
                    var index = _.findIndex(self.biddingDataList, {crewProfId: current.crewProfId});
                    if (index > previous) {
                        return index;
                    } else {
                        return previous;
                    }
                }
            }, -1);


            while (fromIndex <= toIndex) {
                returnCrews.push(self.biddingDataList[fromIndex++]);
            }

            return returnCrews;
        };

        self.saveMaxCrewBiddingDetails = function(postData,successFn, errorFn) {
        	var request = {}
        	request.maxCrewBiddingList= BiddingFactory.populateSaveCrewMaxBiddingRequest(postData);

        	RemoteService.editCrewMaxBidding(request).then(
        			function (response) {
        				successFn(response);
        			},
        			function (error) {
        				errorFn(error.msg);
        			}
        	);
        }



    }
})();
